const MayfairConfig = {
    clientId:
        '29er65cb76f499014d6585d35a253fa1d6a96se39drq63701af8c8fe9d2458ee',
    id: 54,
    name: 'Mayfair',
    fullName: 'Mayfair',
    programName: 'Mayfair Connect',
    primaryColor: '#003E6D',
    theme: 'MayfairTheme',
    favicon:
        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1709745642556_favicon mayfair',

    googleConfig: {
        gID: 'G-8JPXTDMTKW',
        keywordsContent:
            'Mayfair real estate referral programs, Mayfair real estate referral program, Mayfair real estate refer and earn, Mayfair real estate project refer, Mayfair real estate, Mayfair real estate loyalty program, Mayfair real estate news, Mayfair real estate upcoming projects in Bengaluru, Mayfair real estate launch Mayfair real estate, Mayfair real estate launch, Mayfair real estate program, Mayfair real estate projects, Mayfair real estate blogs, Mayfair real estate offers, Mayfair real estate upcoming projects in Bengaluru, Mayfair real estate events, Mayfair, Mayfair, Mayfair real estate best residential projects, Mayfair real estate real estate developers, All New Projects by Mayfair real estate Builders & Developers, Ongoing Projects by Mayfair real estate Pvt Ltd, Mayfair real estate Bengaluru, Mayfair real estate new program, Mayfair press release, Mayfair upcoming projects, JP property group, Mayfair bangalore, JP real estate, JP reit, jitu virwani, JP commercial projects, Mayfair projects, Mayfair projects in bangalore',
        descriptionContent:
            "We present to you a bouquet of such experiences and more with Mayfair - a bespoke loyalty and referral programme that's designed exclusively for Mayfair homeowners",
        authorContent: 'Mayfair'
    },

    facebookPixelConfig: {
        id: '605020088674170', //PROD
        metaName: 'facebook-domain-verification',
        metaContent: ''
    },
    webengageLic: 'in~~99199244',
    uatFacebookPixelConfig: {
        id: '',
        metaName: '',
        metaContent: ''
    },

    layouts: {
        blogs: 'Layout5'
    },
    activateReferPage: false,
    manuallySelectReward: true,
    logoLeft: {
        name: 'Mayfair Logo',
        url: 'https://cdn.loyalie.in/1725609848338_mayfair%20connect%20logo',
        stickyNavBarLogoClass: ' block h-12 2xl:h-14 pl-3 xl:pl-14 ',
        baseNavBarLogoClass: 'h-12 lg:h-12 2xl:h-14 pl-3 xl:pl-14 '
    },

    logoRight: {
        name: 'JPInfra Logo',
        url: 'https://cdn.loyalie.in/1725610566900_mayfair%20logo',
        stickyNavBarLogoClass:
            'hidden lg:block lg:h-12 2xl:h-14 pr-3 xl:pr-14 ',
        baseNavBarLogoClass: 'h-12 lg:h-12 2xl:h-14 pr-3 xl:pr-14 '
    },

    navBarConfig: {
        dropDown: true,
        font: `font-Poppins`,
        height: 'h-20 2xl:h-24',
        mobileIconColor: 'text-white',
        dropDownBg: 'bg-primary',
        showActiveLinkColor: false,
        footerNavItemClass: `tracking-widest uppercase text-white text-[12px] md:text-[14px] lg:text-white hover:text-white font-semibold lg:text-[12px] xl:text-[14px] 3xl:text-lg  font-Poppins`,
        baseNavBar: {
            border: true,
            borderClass: 'border-b-[0px] border-primary-focus',
            backgroundColor: 'bg-primary-content', // default: transparent
            containerClass: '',
            itemClass:
                'uppercase lg:mr-7 tracking-widest text-white text-[14px] lg:text-white hover:text-white font-semibold lg:text-[12px] xl:text-[14px] 3xl:text-lg ',
            dropDownContainerClass: `hover:text-white lg:hover:text-primary lg:hover:bg-white lg:focus:text-white lg:focus:bg-primary lg:focus:outline-none lg:focus:shadow-outline  `,
            dropDownItemClass:
                'tracking-widest text-white lg:text-white text-[14px] font-semibold lg:text-[12px] xl:text-[14px] 3xl:text-lg '
        },

        stickyNavBar: {
            border: true,
            borderClass: 'border-b-[0px] border-primary-focus',
            backgroundColor: 'bg-primary-content', //default: primary-content,
            containerClass: '', //entire Nav Bar Class (add min-w-full for godrej navbar effect)
            itemClass:
                'uppercase lg:mr-7 tracking-widest text-white text-[14px] lg:text-white hover:text-white font-semibold lg:text-[12px] xl:text-[14px] 3xl:text-lg ' // Each list element in NavBar (Text color, hover color, size)
        }
    },

    bannerNegativeTopMarginClass: '', //corresponding to navBarHeightClass
    scrollToTargetAdjustedValue: 92,

    clientButtonClassName: `mx-auto text-center mt-3 font-medium text-[15px] xl:text-[17px] tracking-wider bg-primary-focus text-white py-2.5 xl:py-3 px-8 font-Poppins`,
    increasePageSize: true, // if event layout 2 then true otherwise false
    showFooterRoutes: true,

    routes: {
        home: {
            name: 'OVERVIEW',
            path: '/',
            show: true,

            components: [
                {
                    type: 'BANNER_NEW',
                    backgroundImage:
                        'https://cdn.loyalie.in/1725862033326_Homepage%20Banner',
                    backgroundImageMobile:
                        'https://cdn.loyalie.in/1725862033326_Homepage%20Banner',
                    linearGradient: {
                        R: '0',
                        G: '0',
                        B: '0',
                        opacity: '0',
                        size: 'cover'
                    },
                    bannerContainerClass:
                        'h-[82vh] 2xl:h-[95vh] bg-center lg:bg-right-center lg:bg-cover ',
                    bannerItemContainerClass:
                        'items-center justify-center  px-8 md:px-10 xl:px-16 ',
                    position: 'text-left',
                    components: [
                        {
                            type: 'CUSTOM',
                            className:
                                'text-center md:w-[80%] mx-auto md:mx-0 lg:px-4 py-20 md:p-8 xl:p-10',
                            components: [
                                {
                                    type: 'TEXT',
                                    content: 'A WORLD FULL OF POSSIBILITIES',
                                    className: `inline-block uppercase text-white tracking-wide leading-[1.1] text-[30px] md:text-[25px] xl:text-[35px]  font-Square721BT_Bold`
                                },
                                {
                                    type: 'IMAGE',
                                    url: 'https://cdn.loyalie.in/1725609848338_mayfair%20connect%20logo',
                                    position: 'center',
                                    className:
                                        'w-[80%] md:w-[50%] lg:w-[40%] pt-3'
                                },
                                {
                                    type: 'TEXT',
                                    content:
                                        'A Bespoke Loyalty Program Curated Just For You',
                                    className: `pt-3 text-[16px] md:text-[15px] lg:text-[17px] xl:text-[19px] 2xl:text-[20px] text-white tracking-wider font-normal self-center break-words font-Poppins`
                                }
                            ]
                        }
                    ]
                },

                {
                    type: 'CUSTOM',
                    id: '',
                    url: '',
                    linearGradient: {
                        R: '255',
                        G: '255',
                        B: '255',
                        opacity: '0'
                    },
                    className:
                        'flex flex-col justify-center text-left py-10 md:py-14 md:px-4 w-[90%] mx-auto',
                    components: [
                        {
                            type: 'CUSTOM',
                            className:
                                'flex space-x-3 2xl:space-x-4 self-center w-[90%] 2xl:w-[80%]',
                            components: [
                                {
                                    type: 'TEXT',
                                    content: 'About',
                                    className: `text-black tracking-wide leading-[1] text-[23px] md:text-[25px] xl:text-[30px] 2xl:text-[40px] font-normal font-Poppins`
                                },
                                {
                                    type: 'TEXT',
                                    content: 'Mayfair Connect',
                                    className: `text-primary tracking-wide leading-[1] text-[23px] md:text-[25px] xl:text-[30px] 2xl:text-[40px] font-normal font-Square721BT_Bold`
                                }
                            ]
                        },

                        {
                            type: 'TEXT',
                            content:
                                'Mayfair Connect is an exclusive loyalty program curated for the homeowners of Mayfair Realty. The loyalty program is created to enrich your experience though events, offers, and reward you for expanding the community. Become part of this vibrant community and unlock a world of exclusive benefits.',
                            className: `pt-3 lg:pt-5 text-[17px] xl:text-[20px] text-secondary-focus leading-6 xl:leading-[27px] self-center w-[90%] lg:w-[90%] 2xl:w-[80%] break-words  font-Poppins`
                        }
                    ]
                },
                {
                    type: 'CUSTOM',
                    id: '',
                    url: 'https://cdn.loyalie.in/1725612769703_Rewarding%20refferals%20BG',
                    linearGradient: {
                        R: '255',
                        G: '255',
                        B: '255',
                        opacity: '0',
                        size: 'cover',
                        position: 'right'
                    },
                    bannerItemContainerClass: 'bg-cover',
                    className: 'text-left p-3 xl:p-5 bg-center',
                    components: [
                        {
                            type: 'CUSTOM',
                            className:
                                'flex flex-col  items-center lg:items-start lg:justify-center p-1 md:p-4 ',
                            bannerItemContainerClass: '',
                            components: [
                                {
                                    type: 'CUSTOM',
                                    className:
                                        'text-center self-center w-[95%] md:w-[70%] lg:w-[60%] 2xl:w-[55%] py-14',
                                    bannerItemContainerClass: '',
                                    components: [
                                        {
                                            type: 'TEXT',
                                            content: 'REWARDING REFERRALS',
                                            className: `text-white uppercase tracking-wide text-[22px] md:text-[25px] lg:text-[30px] xl:text-[35px] 2xl:text-[40px] leading-[1.2] pb-5 font-Square721BT_Bold`
                                        },

                                        {
                                            type: 'TEXT',
                                            content:
                                                'Earn referral rewards for referring friends and family who purchase a Mayfair property.',
                                            className: `text-white text-[22px] lg:text-[28px] xl:text-[32px] 2xl:text-[35px] leading-[1.2] font-Poppins`
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'CUSTOM',
                    id: '',
                    url: '',
                    linearGradient: {
                        R: '255',
                        G: '255',
                        B: '255',
                        opacity: '0'
                    },
                    className:
                        ' overflow-x-scroll lg:overflow-x-hidden grid grid-cols-3 gap-x-80 lg:gap-x-10 text-center py-14 w-[75%] lg:w-[90%] xl:w-[80%]  mx-auto mb-10 lg:mb-0 ',
                    components: [
                        {
                            type: 'CUSTOM',
                            className: 'w-[280px] lg:w-full ',
                            components: [
                                {
                                    type: 'TEXT',
                                    content: ' ',
                                    className: `text-black tracking-wide leading-[1] w-10 h-10 bg-primary text-[35px] md:text-[25px] font-normal mb-5 rounded-full mx-auto font-Square721BT_Bold`
                                },
                                {
                                    type: 'TEXT',
                                    content: 'Exclusive Offers',
                                    className: `text-black tracking-wide leading-[1]  text-[22px] 2xl:text-[25px] font-normal font-Square721BT_Bold`
                                },
                                {
                                    type: 'TEXT',
                                    content:
                                        'Enjoy curated discounts and promotions from a wide range of renowned brands.',
                                    className: `pt-3 lg:pt-5 text-[17px] xl:text-[18px] 2xl:text-[20px] text-secondary-focus leading-[1.3] self-center w-[90%] lg:w-[90%] 2xl:w-[80%] mx-auto break-words h-[100px] lg:h-[115px] xl:h-[120px]  2xl:h-[125px] font-Poppins`
                                },
                                {
                                    type: 'BUTTON',
                                    content: 'AVAIL OFFERS',
                                    className: `mx-auto text-center mt-5 font-medium text-[15px] 2xl:text-[17px] tracking-wider bg-primary text-white py-2.5 px-5 rounded-full font-Square721BT_Bold`,
                                    path: 'deals',
                                    onClick: 'CHANGE_PATH'
                                }
                            ]
                        },
                        {
                            type: 'CUSTOM',
                            className: 'w-[280px] lg:w-full',
                            components: [
                                {
                                    type: 'TEXT',
                                    content: ' ',
                                    className: `text-black tracking-wide leading-[1] w-10 h-10 bg-black text-[35px] md:text-[25px] font-normal mb-5 rounded-full mx-auto font-Square721BT_Bold`
                                },
                                {
                                    type: 'TEXT',
                                    content: 'Events & Workshops',
                                    className: `text-black tracking-wide leading-[1]  text-[22px] 2xl:text-[25px] font-normal font-Square721BT_Bold`
                                },
                                {
                                    type: 'TEXT',
                                    content:
                                        'Enjoy curated offline workshops and events from top collaborators, adding more delight to your experiences.',
                                    className: `pt-3 lg:pt-5 text-[17px] xl:text-[18px] 2xl:text-[20px] text-secondary-focus leading-[1.3] self-center w-[95%] 2xl:w-[90%] mx-auto break-words h-[100px] lg:h-[115px] xl:h-[120px]  2xl:h-[125px] font-Poppins`
                                },
                                {
                                    type: 'BUTTON',
                                    content: 'KNOW MORE',
                                    className: `mx-auto text-center mt-5 font-medium text-[15px] 2xl:text-[17px] tracking-wider bg-primary text-white py-2.5 px-5 rounded-full font-Square721BT_Bold`,
                                    path: 'events',
                                    onClick: 'CHANGE_PATH'
                                }
                            ]
                        },
                        {
                            type: 'CUSTOM',
                            className: 'w-[280px] lg:w-full',
                            components: [
                                {
                                    type: 'TEXT',
                                    content: ' ',
                                    className: `text-black tracking-wide leading-[1] w-10 h-10 bg-primary text-[35px] md:text-[25px] font-normal mb-5 rounded-full mx-auto font-Square721BT_Bold`
                                },
                                {
                                    type: 'TEXT',
                                    content: 'Engaging Community',
                                    className: `text-black tracking-wide leading-[1] text-[22px] 2xl:text-[25px] font-normal font-Square721BT_Bold`
                                },
                                {
                                    type: 'TEXT',
                                    content:
                                        'Stay informed about the latest trends through our interactive blogs.',
                                    className: `pt-3 lg:pt-5 text-[17px] xl:text-[18px] 2xl:text-[20px] text-secondary-focus leading-[1.3] self-center w-[90%] lg:w-[80%]  mx-auto break-words h-[100px] lg:h-[115px] xl:h-[120px]  2xl:h-[125px]  font-Poppins`
                                },
                                {
                                    type: 'BUTTON',
                                    content: 'READ MORE',
                                    className: `mx-auto text-center mt-5 font-medium text-[15px] 2xl:text-[17px] tracking-wider bg-primary text-white py-2.5 px-5 rounded-full font-Square721BT_Bold`,
                                    path: 'blogs',
                                    onClick: 'CHANGE_PATH'
                                }
                            ]
                        }
                    ]
                },

                {
                    type: 'CUSTOM',
                    id: '',
                    url: '',
                    linearGradient: {
                        R: '220',
                        G: '220',
                        B: '220',
                        opacity: '1',
                        size: 'cover',
                        position: 'right'
                    },
                    bannerItemContainerClass: 'bg-cover',
                    className: 'text-left p-3 xl:p-5 bg-center',
                    components: [
                        {
                            type: 'CUSTOM',
                            className:
                                'flex flex-col  items-center lg:items-start lg:justify-center p-1 md:p-4 ',
                            bannerItemContainerClass: '',
                            components: [
                                {
                                    type: 'CUSTOM',
                                    className:
                                        'text-center self-center w-[90%] lg:w-[80%] py-6',
                                    bannerItemContainerClass: '',
                                    components: [
                                        {
                                            type: 'TEXT',
                                            content: 'OFFERS OF THE MONTH',
                                            className: `text-black uppercase tracking-wide text-[25px] lg:text-[28px] xl:text-[32px] 2xl:text-[35px] leading-[1.2] pb-5 font-Poppins`
                                        },
                                        {
                                            type: 'CAROUSEL',
                                            customSlide: true,
                                            caraouselClassName:
                                                'mx-10  md:mx-20 lg:mx-20 px-5 md:px-10 lg:px-24 text-white self-auto',
                                            imageContainerClassName:
                                                'mx-10 lg:m-4 p-6 md:p-5 lg:p-4 xl:p-7 rounded-[100%] bg-white ',
                                            imageClassName:
                                                ' lg:bg-cover object-cover',
                                            captionClass: ` text-sm lg:text-lg font-semibold leading-8 font-Poppins`,
                                            arrows: true,
                                            autoplay: true,
                                            autoplaySpeed: 3000,
                                            infinite: true,
                                            dots: false,
                                            slidesToShow: 5,
                                            pauseOnHover: true,
                                            speed: 1500,
                                            onImageClick: 'NO_ACTION',
                                            getVendorLogos: true
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },

                {
                    type: 'BLOG_LAYOUT_LIST',
                    backgroundImage:
                        'https://cdn.loyalie.in/1725862646861_Blog%20sec%20banner',
                    linearGradient: {
                        R: '0',
                        G: '0',
                        B: '0',
                        opacity: '0'
                    },
                    titleClass: ``,
                    summaryClass: ``,
                    buttonClass: ``,
                    headingClass: ``,
                    listTitleClass: ``
                },

                //REFERRAL FORM
                // {
                //     type: 'REFERRAL_FORM_BANNER'
                // },

                // OUR PROJECTS
                {
                    type: 'CUSTOM',
                    url: '',
                    linearGradient: {
                        R: '255',
                        G: '255',
                        B: '255',
                        opacity: '1',
                        size: '40%'
                    },
                    className:
                        'xl:text-center text-center xl:w-full w-[100%] text-[#f58020] pt-10 pb-16 lg:pb-28  -mb-24   ',
                    components: [
                        {
                            type: 'TEXT',
                            content: 'OUR PROJECTS',
                            className: `font-Square721BT_Bold text-secondary text-center tracking-wide leading-[1] text-[35px] md:text-[25px] xl:text-[30px] 2xl:text-[40px] font-normal `
                        },
                        {
                            type: 'CAROUSEL',
                            customSlide: true,
                            caraouselClassName:
                                'px-8 w-[99%] md:w-[97%] xl:w-[84%] 2xl:w-[92%] 3xl:w-[80%] mx-auto md:pb-10 pt-1 relative pb-16 lg:py-5',
                            imageContainerClassName: 'm-4 relative',
                            imageClassName:
                                'w-[93%] md:w-[92%] lg:w-[93%] xl:w-[92.5%] 2xl:w-[90%] mx-auto h-[150px] xl:h-[169px] 2xl:h-[208px] object-cover object-center lg:bg-cover',
                            captionClass: ` w-[83.5%] mx-auto uppercase text-sm lg:text-lg leading-[1] py-2.5 lg:py-2 -mt-4 bg-secondary !text-white font-Poppins`,
                            xlSlidesToShow: 3,
                            arrows: true,
                            autoplay: true,
                            autoplaySpeed: 3000,
                            infinite: true,
                            dots: false,
                            slidesToShow: 3,
                            pauseOnHover: true,
                            speed: 3000,
                            onImageClick: 'OPEN_URL_NEW_WINDOW',
                            // getProjects: true,
                            internalRedirect: true,
                            imgArr: [
                                {
                                    imgUrl: 'https://reloydev.s3.ap-south-1.amazonaws.com/Document/Project/2/mbPOB6MRd8.jpg',
                                    alt: 'img',
                                    url: `/projects/detail?projectId=2`,
                                    caption: 'Mayfair Virar Gardens'
                                },
                                {
                                    imgUrl: 'https://mayfairprod.s3.ap-south-1.amazonaws.com/Document/Project/4/qSDVwupKG7.jpg',
                                    alt: 'img',
                                    url: `/projects/detail?projectId=4`,
                                    caption: 'Mayfair Muse'
                                },
                                {
                                    imgUrl: 'https://reloydev.s3.ap-south-1.amazonaws.com/Document/Project/5/8bFJPOJ7vB.jpg',
                                    alt: 'img',
                                    url: `/projects/detail?projectId=5`,
                                    caption: 'Mayfair Liv'
                                },
                                {
                                    imgUrl: 'https://mayfairprod.s3.ap-south-1.amazonaws.com/Document/Project/58/LRh1kFJOZQ.jpg',
                                    alt: 'img',
                                    url: `/projects/detail?projectId=58`,
                                    caption: 'Mayfair Breeze'
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    referPage: {
        banner: {
            loginBannerComponents: [
                {
                    type: 'BANNER',
                    linearGradient: {
                        R: '0',
                        G: '0',
                        B: '0',
                        opacity: '0'
                    },
                    backgroundImage:
                        'https://reloydev.s3.ap-south-1.amazonaws.com/Website/Uploads/JP-Infra/Images/83352489.jpg',
                    backgroundImageMobile:
                        'https://reloydev.s3.ap-south-1.amazonaws.com/Website/Uploads/JP-Infra/Images/83352489.jpg',
                    bannerContainerClassName:
                        'relative hero hero-content max-w-full h-[75vh] md:h-[70vh] object-cover bg-center lg:bg-left',
                    components: [
                        {
                            type: 'TEXT',
                            content:
                                'Refer your loved ones and get rewards on every successful referral ',
                            className: `text-center lg:text-left text-black text-[15px] md:text-[20px] xl:text-[25px] uppercase my-5 tracking-widest lg:w-[55%] ml-auto  font-Poppins`
                        },
                        {
                            type: 'CUSTOM',
                            className: 'flex lg:w-[55%] ml-auto',
                            components: [
                                {
                                    type: 'BUTTON',
                                    content: 'Start Referring Now',
                                    onClick: 'OPEN_LOGIN',
                                    className: `text-center mt-3 font-medium text-[15px] xl:text-[17px] tracking-wider bg-primary-focus text-white py-2.5 xl:py-3 px-8 mx-auto lg:mx-0 font-Poppins`
                                }
                            ]
                        }
                    ]
                }
            ]
        },

        components: [],

        customize: {}
    },
    blogs: {
        banner: {
            bannerContainerClassName:
                'hidden md:hero hero-content max-w-full h-[450px] bg-center md:bg-right  mx-auto text-center border-b-[3px] border-primary-focus',
            linearGradient: {
                string: '100,65,43,0.7',
                R: '20',
                G: '20',
                B: '20',
                opacity: '0.20'
            },
            backgroundImage: 'https://cdn.loyalie.in/19150976.jpg',
            backgroundImageMobile: 'https://cdn.loyalie.in/19150976.jpg',
            components: [
                {
                    type: 'TEXT',
                    content: 'MAYFAIR READERS’ CLUB',
                    className: `mt-12 md:mt-10 mb-5 leading-[1.1] text-[30px] md:text-[25px] xl:text-[35px] tracking-wider font-Square721BT_Bold`
                },
                {
                    type: 'DIVIDER',
                    className:
                        'mt-1 self-center mx-auto w-[20%] g:w-[15%] xl:w-[20%] bg-primary-focus border-none h-[6px]',
                    classNameContainer: ''
                },
                {
                    type: 'TEXT',
                    content:
                        'Bringing Together Information And Entertainment For You.',
                    className: `font-normal mt-5 mb-3  text-xl md:text-[16px] xl:text-[17px] tracking-wider font-Poppins`
                },
                {
                    type: 'BUTTON',
                    content: 'Read More',
                    scrollTo: 'blogs_section',
                    onClick: 'SCROLL',
                    className: `mx-auto text-center mt-3 font-medium text-[12px] md:text-[17px] tracking-wider bg-primary-focus text-white py-3 2xl:py-3 px-12 md:px-8 font-Poppins`
                }
            ],
            loginBannerComponents: [
                {
                    type: 'TEXT',
                    content: 'MAYFAIR READERS’ CLUB',
                    className: `mt-12 md:mt-10 mb-5 leading-[1.1] text-[30px] md:text-[25px] xl:text-[35px]  tracking-wider font-Square721BT_Bold`
                },
                {
                    type: 'DIVIDER',
                    className:
                        'mt-1 self-center mx-auto w-[20%] g:w-[15%] xl:w-[20%] bg-primary-focus border-none h-[6px]',
                    classNameContainer: ''
                },
                {
                    type: 'TEXT',
                    content:
                        'Bringing Together Information And Entertainment For You.',
                    className: `font-normal mt-5 mb-3  text-xl md:text-base lg:text-[17px] tracking-wider font-Poppins`
                },
                {
                    type: 'BUTTON',
                    content: 'Login To Read Now',
                    onClick: 'OPEN_LOGIN',
                    className: `mx-auto text-center mt-3 font-medium text-[12px] md:text-[17px] tracking-wider bg-primary-focus text-white py-3 2xl:py-3 px-12 md:px-8 font-Square721BT_Bold`
                }
            ]
        },
        comments: {
            commentButtonClass: 'bg-primary-focus text-white',
            initialsClass: ' '
        },
        primaryColor: '',
        fontHeading: `font-Square721BT_Bold`,
        fontBody: `font-Poppins`,
        button: {
            position: 'self-end',
            bgColor: true,
            border: false
        },
        sliderBanner: {
            featuredPost: {
                featuredPostClass: ``,
                headingClass: `leading-[1.1] text-[30px] md:text-[25px] xl:text-[32px] uppercase tracking-tight text-secondary-focus mt-3 leading-10 break-words`,
                summaryClass: ``
            },
            sectionHeadings: `!text-primary leading-[1.1] text-[30px] md:text-[25px] xl:text-[35px] tracking-wide`
        },
        layout5: {
            headingClass: `text-[18px] 3xl:text-[20px] tracking-tight leading-[1.2] `,
            categoryClass: ``,
            summaryClass: ``,
            buttonClass: ``,
            dateClass: ``
        }
    },
    events: {
        banner: {
            linearGradient: {
                R: '0',
                G: '0',
                B: '0',
                opacity: '0',
                size: 'cover'
            },

            negativeMargin: ' ',
            containerClass: ' text-white lg:w-[50%] bg-top',
            heading: '',
            headingClass: ` text-center lg:w-[70%] eading-[1.1] text-[30px] md:text-[25px] xl:text-[35px]  text-white uppercase font-Square721BT_Bold`,
            subHeading: '',
            subHeadingClass: `text-accent uppercase font-semibold text-[33px] font-Square721BT_Bold`
        },
        loginBanner: {
            bannerContainerClassName:
                'mt-20 2xl:mt-24 hero hero-content lg:bg-right bg-cover max-w-full h-[55vh] md:h-[70vh] lg:h-[90vh] mx-auto text-center ',
            components: [
                {
                    type: 'TEXT',
                    content: 'CURATED WORKSHOPS AND EVENTS',
                    className: `font-semibold mt-12 md:mt-10 mb-5 text-2xl md:text-4xl lg:text-[40px] tracking-wider font-Square721BT_Bold`
                },
                {
                    type: 'DIVIDER',
                    className:
                        'mt-1 self-center mx-auto w-[20%] lg:w-[20%] bg-primary border-none h-[6px]',
                    classNameContainer: ''
                },
                {
                    type: 'TEXT',
                    content:
                        'Meet and connect with like-minded people of your bespoke community',
                    className: `font-normal mt-5 mb-3  text-xl md:text-base lg:text-[17px] tracking-wider font-Square721BT_Bold`
                },
                {
                    type: 'BUTTON',
                    content: 'Login To Participate Now',
                    onClick: 'OPEN_LOGIN',
                    className: `uppercase md:mt-6 text-[12px] md:text-[17px] 2xl:text-lg tracking-wider bg-primary text-white rounded-md py-2 md:py-2 2xl:py-[7px] px-10 md:px-5 font-Square721BT_Bold`
                }
            ]
        },
        fontHeading: `font-Square721BT_Bold`,
        fontBody: `font-Poppins`,
        eventsSection: {
            headingClass: `text-[32px] xl:text-[42px] tracking-tight text-primary mt-14 leading-10 border-b-2 border-primary pb-2 `,
            filterHeadingClass: ``
        },
        eventLayout: {
            titleClass: `text-primary-focus !text-[22px] `
        }
    },

    deals: {
        dealsSection: {
            overlayClass: '',
            additionalTextClass: `text-primary text-2xl xl:text-3xl leading-7 xl:leading-9 font-Square721BT_Bold `,
            subAdditionalTextClass: ` font-normal text-[14px] text-neutral font-Poppins`,
            noDealsClass: `text-primary text-2xl text-center my-6
         font-Poppins`
        },
        dealLayout: {
            listTitleClass: `text-2xl lg:text-xl leading-6 lg:leading-5 text-primary font-Poppins`,
            listBodyClass: `font-Poppins`,
            titleClassName: ` text-2xl xl:text-4xl text-primary  leading-7 xl:leading-9 font-normal font-Square721BT_Bold `,
            termsAndConditionsClassName: `font-semibold capitalize text-neutral text-sm  font-Poppins`,
            redeemNowButtonConfig: {
                type: 'BUTTON',
                content: 'Redeem Now',
                className: `hover:shadow-xl rounded bg-primary-focus hover:bg-primary text-white font-medium self-center text-[16px] py-2.5 px-7 py-3 2xl:py-3 px-7 md:px-8 font-Poppins`
            }
        }
    },
    projects: {
        components: [
            // {
            //     type: 'BANNER',
            //     linearGradient: {
            //         string: '100,65,43,0.7',
            //         R: '20',
            //         G: '20',
            //         B: '20',
            //         opacity: '0.30'
            //     },
            //     backgroundImage: 'https://cdn.loyalie.in/12147265.jpg',
            //     backgroundImageMobile: 'https://cdn.loyalie.in/12147265.jpg',
            //     bannerContainerClassName:
            //         'hidden md:hero hero-content max-w-full h-[87vh]  md:bg-bottom',
            //     components: [
            //         {
            //             type: 'TEXT',
            //             content: 'MAYFAIR RESIDENTIAL PROJECTS',
            //             className: `text-center leading-[1.1] text-[30px] md:text-[25px] xl:text-[35px] text-white uppercase font-Square721BT_Bold`
            //         },
            //         {
            //             type: 'DIVIDER',
            //             className:
            //                 'mt-1 self-center mx-auto w-[40%] md:w-[35%] lg:w-[15%] xl:w-[20%] bg-primary-focus border-none h-[6px]',
            //             classNameContainer: ''
            //         }
            //     ]
            // }
        ]
    },

    termsAndConditions: {
        fontHeading: `font-Square721BT_Bold`,
        fontBody: `font-Poppins`,
        terms: [
            '“Referrer” shall mean either of (i) an existing eligible customer having booked a unit in a Mayfair  project, and has entered into a registered Agreement to Sell; or (ii) employee of Mayfair ; or (iii) a visit done not booked person/client (VDNB); or (iv) influencers; and wishes to introduce/refer another person(s) to book a unit in any of the eligible registered real estate project/s to be developed by Mayfair  or any of its sister concerns/subsidiaries/affiliates (“Mayfair  Project/s”). ‘Referred’ shall mean the eligible person introduced/referred to by the Referrer and who intends to book one or more units in any of the eligible registered real estate Mayfair  Project/s and registers an agreement for sale for such unit(s).',
            'Referrer participation in the Referral Reward Program shall be subject to his/her/them producing a copy of a valid and subsisting registered Agreement to Sell executed in his/her/their favor by Mayfair .',
            'Referrer shall not be able to refer existing customer(s) of Mayfair . Referrer shall not be able to refer customer(s) who has/have in the last three months: (i) either made enquires (in any form, whether by way of site visit or otherwise with Mayfair  or (ii) is/are already registered with Mayfair  as a ‘Direct/Walk-in Customer’ or (iii) has/have come through any of the Mayfair ’s Channel Partner or any other source. Assigning Referral Reward and determining eligibility as to who qualifies as ‘Referrer’ and ‘Referred’ will be at sole discretion of Reloy and the same shall not be challenged/contested by the Referrer and/or the Referred at any point of time.',
            'In the event that a referral is submitted twice from different Referrers, then the first referral received will be eligible for the Reward (subject to other applicable terms herein) and shall not be disputed by the other Referrers.',
            'Referrals are not valid where the Referrer and the Referred party are one and the same person.',

            'Referrals will be valid for three months from the date a person/party is ‘Referred’ unless such person/party has paid any booking amount to Mayfair  within the said period of three months.',
            'By accepting our terms and conditions, both Referrer and Referred represent that they have the authority to disclose the name and details of the person or business to Mayfair ',
            'Subject to the terms mentioned herein, the reward will be paid to the Referrer within 90 (ninety) days from the date of registration of the agreement for sale by the Referred party. The reward will be in the form of gift vouchers/cards having value and a validity period with applicable terms and conditions.',
            'This Referral Reward Program cannot be clubbed with any other offer /scheme, whether run by the Mayfair  or otherwise.',
            'Customers who are employees of working either in marketing, sales or CRM departments/team and employees of Reloy will not be eligible for participating in this Referral Reward Program and accordingly shall not be entitled for any reward.',
            'Reloy will not be liable for any unforeseen delay/deficiency/defect in any product or services disbursed as rewards by it or on account of any dispute relating to right to utilize the product or services subsequent to disbursement of the same.',
            'The terms and conditions of this program are subject to change at any time. Reloy will intimate the same to the Referrer. This program may be terminated at the discretion of Reloy.',
            'All disputes shall be subject to exclusive jurisdiction of Mumbai courts.'
        ]
    },
    myProfile: {
        appContainerClassName: 'text-primary border-primary-focus'
    },
    footer: {
        backgroundColor: '',
        content:
            'Reloy is run by Loyalie IT-Solutions Pvt. Ltd. This referral program is run by Loyalie IT Solutions Pvt. Ltd. and the referral payout will be processed by them. Loyalie IT Solutions Pvt. Ltd. is registered as a Real Estate Agent under RERA in Maharashtra MAHARERA NO - A51900010267 | Haryana RERA No. - HRERA-PKL-REA-239-2020 | Tamil Nadu RERA NO - TN/Agent/0092/2023 | Karnataka RERA NO-PRM/KA/RERA/1251/309/AG/180524/000935 | West Bengal RERA NO – HIRA/A/KOL/2019/000350 | Uttar Pradesh RERA NO – UPRERAAGT22593 | Gujarat RERA No: AG/GJ/AHMEDABAD/AHMEDABAD CITY/AUDA/AA01891/090327R1 | Delhi RERA Application Reference No: 22-3754-2891 | Goa RERA NO – AGGO02210817 | Telangana RERA NO – A02500001321 | maharera.mahaonline.gov.in | haryanarera.gov.in | www.tnrera.in | rera.karnataka.gov.in | http://hira.wb.gov.in | https://www.up-rera.in | https://gujrera.gujarat.gov.in | https://rera.delhi.gov.in | https://rera.goa.gov.in | http://rera.telangana.gov.in'
    },

    referralForm: {
        disableInfluencerLink: false,
        backgroundImage: 'https://cdn.loyalie.in/7023826.jpg',
        bgOverlay: false,
        linearGradient: {
            degree: '90deg',
            R1: '20',
            G1: '20',
            B1: '20',
            opacity1: '0',
            R2: '52',
            G2: '52',
            B2: '52',
            opacity2: '0'
        },
        referAnyProject: false,
        userTypes: {
            length: 3,
            siteVisitor: false,
            siteVisitorHeading: '',
            bookedCustomer: true,
            bookedCustomerHeading1: 'I own a',
            // bookedCustomerHeading2: 'JP Infra Property',

            employee: true,
            employeeHeading1: 'I am a',
            // employeeHeading1: 'JP Infra Employee',

            salesAdmin: true,
            salesAdminHeading1: 'I am an',
            // salesAdminHeading2: 'JP Infra Sales Admin',

            influencer: false,
            influencerHeading: ''
        },
        customConfig: {
            welcomeContent: '',
            headingColor: 'text-black',
            userBgColor: 'bg-transparent',
            borderColor: 'border-primary',
            animateUserType: true
        },
        formContent: {
            heading: '"Build your own bespoke community"',
            headingClass: `self-center text-white sm:mt-0 text-3xl md:text-4xl xl:text-[48px] 2xl:text-[62px] w-[80%] lg:w-[50%] xl:w-[80%] 2xl:w-[90%] text-center tracking-wide leading-8 xl:leading-[50px] 2xl:leading-[60px] font-Square721BT_Bold`
        },
        leadEmailMandatory: false
    }
};
export default MayfairConfig;
